// extracted by mini-css-extract-plugin
export default {"time":"CreatedDay_time__lNKzV","-modal":"CreatedDay_-modal__Ct1SM"};